import { useActiveAddress } from "@arweave-wallet-kit/react"
import { useQuery } from "@tanstack/react-query"

import { useAo } from "../ao/ao"
import { getPoolPnlHistory } from "../ao/pool"

function usePoolPnlHistory(user?: string) {
  const ao = useAo()
  const account = useActiveAddress()

  return useQuery({
    queryKey: ["poolPnlHistory", user || account],
    queryFn: async () => {
      const result = await getPoolPnlHistory(user ?? (account as string), ao)
      console.log("onPoolPnlHistory", result)
      return result
    },
    enabled: !!account,
    staleTime: 1000 * 3600,
  })
}

export default usePoolPnlHistory
